<template>

<DialogBox :settings="settings" save-on-enter @save="reassignAll">
    <div class="pa-3">

            <div style="text-align:center;margin-bottom:15px;display:flex">
                <div style="flex-grow:1">
                    <UserChooser v-model="fromUser"  style="margin:auto" :contact="fromUser" :contacts="users" label="Assign From" @select="loadTasksForUser"/>
                </div>
                <div style="padding:10px;">to</div>
                <div style="flex-grow:1">
                    <UserChooser v-model="toUser"  style="margin:auto" :contact="toUser" :contacts="users" label="Reassign To" @select="hasDestination = true"/>
                </div>
            </div>
            <div>For the next {{days}} days</div>
            <v-slider v-model="days" :min="0" :max="28"></v-slider>
            <div style="font-size:20px;color:#999">
                {{tasks.length}} tasks
            </div>

    </div>

    <template slot="footer">
        <v-btn @click="reassign" :disabled="tasks.length == 0" class="primary">Assign</v-btn>
    </template>

</DialogBox>    

</template>

<script>
import Vue from 'vue'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import MergeHelpers from '../helpers/MergeHelpers'
import FirebaseHelpers from '../helpers/FirebaseHelpers'
import DataHelpers from '../helpers/DataHelpers'
import DateHelpers from '../helpers/DateHelpers'
import LookupData from '../helpers/LookupData'
import StringHelpers from '../helpers/StringHelpers'
import Utilities from '../helpers/Utilities'
import UserChooser from '../ui-elements/UserChooser'

import DialogBox from '../ui-elements/DialogBox'
import NiceData from '../data/NiceData';
import AlertHelpers from '../helpers/AlertHelpers'
import TemplateHelpers from '../helpers/TemplateHelpers'
import EmailHelpers from '../helpers/EmailHelpers';
import ContactHelpers from '../helpers/ContactHelpers'
import ContactData from '../data/ContactData'
import { dateFormats } from '../helpers/DateHelpers'
import {differenceInDays} from 'date-fns'



import {format} from 'date-fns'
import Template from '../builder/Template.vue'


export default {
props:{
    settings: Object,
},
components:{
    DialogBox,
    UserChooser
},
data() {
    return {
        hasDestination: false,
        fromUser: this.user,
        toUser: null,
        days: 0,
        users: [],
        tasksForUser: [],
    }
},
computed: {
  
    user() {
        return this.$store.getters.user
    },
    tenantKey() {
        return DataHelpers.getTenantKey()
    },
    tasks() {
        const tasks = []
        this.tasksForUser.forEach(task => {
            const daysFromNow = differenceInDays(DateHelpers.toDate(task.due), new Date())
            if(daysFromNow <= this.days)
                tasks.push(task)
        })
        return tasks
    },
    
},
methods: {

    async loadTasksForUser() {
        const uid = this.fromUser.uid
        this.tasksForUser = []
        const ref = DataHelpers.getTenantRef().child('tasks').orderByChild('assigned/uid').equalTo(uid)
        const tasks = await NiceData.fetchItemsFromFirebase(ref)
        this.tasksForUser = tasks
    },

    reassign() {
        if(this.toUser == null) {
            AlertHelpers.showAlert('Select a user')
            return
        }
        this.tasks.forEach(task => {
            const ref = DataHelpers.getTenantRef().child('tasks').child(task.meta.key)
            ref.update({assigned: this.toUser})
        })
        this.loadTasksForUser()
        AlertHelpers.showAlert('Tasks have been reassigned')
    },

    initialiseDialog() {
        
        ContactData.fetchUsers().then(users => {
            console.log('fetching users from Reassign Dialog', users)
            this.users = users
        })            
    },

    reassignAll() {
        
    },

    sendEmail() {

    },



},

created() {
    this.initialiseDialog()
},

watch: {
    'settings.visible' (newVal) {
        if (newVal) {
            this.initialiseDialog()
        }   
    },
    
},

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>


// WEBPACK FOOTER //
// ReassignTasksDialog.vue?7d17aaea